import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "pi-feedback-modal-action-bar",
  templateUrl: "./pi-feedback-modal-action-bar.component.html",
})
export class PiFeedbackModalActionBarComponent {
  @Input()
  public shouldDisableSubmitBtn = false;

  @Output()
  public readonly feedbackSubmit = new EventEmitter();
  @Output()
  public readonly feedbackClose = new EventEmitter();

  public handleSubmitFeedback = (): void => {
    this.feedbackSubmit.emit();
  };

  public handleClose = (): void => {
    this.feedbackClose.emit();
  };
}
